"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedSessionsExtendedDto = exports.SessionExtendedDto = exports.GetSessionsFiltersExtendedDto = exports.PaginatedSessionsDto = exports.SessionDto = exports.GetSessionProductsFiltersDto = exports.GetSessionsFiltersDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class GetSessionsFiltersDto extends general_dto_1.PaginationQuery {
}
exports.GetSessionsFiltersDto = GetSessionsFiltersDto;
class GetSessionProductsFiltersDto extends general_dto_1.PaginationQuery {
}
exports.GetSessionProductsFiltersDto = GetSessionProductsFiltersDto;
class SessionDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.SessionDto = SessionDto;
class PaginatedSessionsDto extends general_dto_1.PaginationResultDto {
}
exports.PaginatedSessionsDto = PaginatedSessionsDto;
// Extended DTOs for enhanced functionality
class GetSessionsFiltersExtendedDto extends GetSessionsFiltersDto {
}
exports.GetSessionsFiltersExtendedDto = GetSessionsFiltersExtendedDto;
class SessionExtendedDto extends SessionDto {
}
exports.SessionExtendedDto = SessionExtendedDto;
class PaginatedSessionsExtendedDto extends general_dto_1.PaginationResultDto {
}
exports.PaginatedSessionsExtendedDto = PaginatedSessionsExtendedDto;
//# sourceMappingURL=session-public.dto.js.map